import { render } from "./SSOAdd.vue?vue&type=template&id=b668f86c"
import script from "./SSOAdd.vue?vue&type=script&lang=js"
export * from "./SSOAdd.vue?vue&type=script&lang=js"

import "./SSOAdd.vue?vue&type=style&index=0&id=b668f86c&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.33.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__